import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router';
import { getAllTheLocationsInfo, getGlobalLocationList, setGlobalLocationFilter } from '../apiclients/streamsapi_bridge';
import {
    MDBAlert,
    MDBBtn,
    MDBCheckbox,
    MDBChip,
    MDBDatatable,
    MDBIcon,
    MDBInput,
    MDBPopconfirm,
    MDBPopconfirmMessage,
    MDBSpinner,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from 'mdb-react-ui-kit';
import { formattedNumber } from './popups/phonenumbers/AddRemoveNumbers';
import { useTranslation } from 'react-i18next';
import PopupLoader from './popups/PopupLoader';
import PopupLoaderNew from './popups/PopupLoaderNew';
import Remove911Locations from './popups/locations/Remove911Location';
import DeleteLocationFilter from './popups/users/DeleteLocationFilter';
import AddLocations from './popups/locations/AddLocations';
import RemoveLocations from './popups/locations/RemoveLocation';
import { customSearch, useAutoFocusSearchAfterLoads } from '../components/CustomSearchUtil/CustomSearch';
import UIConstant from '../apiclients/UIConstant';
import AddNineOneOneLocation from './popups/locations/Add911Location';
import TabIDConstant from '../apiclients/TabIDConstant';

function AllLocations({ basicActive }) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation()
    const [allLocationsInfo, setallLocationsInfo] = useState([]);
    const [allLocationsInfoTemp, setallLocationsInfoTemp] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [LocationSelected, setLocationSelected] = useState("");
    const [LocationSelectedIds, setLocationSelectedIds] = useState([]);
    const [newLocationSelectedIds, setNewLocationSelectedIds] = useState([]);
    const [existLocationSelectIds, setexistLocationSelectIds] = useState([]);
    const [existNewLocationSelectIds, setexistNewLocationSelectIds] = useState([]);
    const [filterLocationList, setfilterLocationList] = useState([]);
    const [displayFilterLocations, setdisplayFilterLocations] = useState([]);
    const [displayNewFilterLocations, setdisplayNewFilterLocations] = useState([]);
    const [filterReRender, setFilterReRender] = useState(false);
    const [searchMainValue, setsearchMainValue] = useState("");
    const [searchEditValue, setsearchEditValue] = useState("");
    const [deleteFilter, setdeleteFilter] = useState(false);
    const deleteFilterToggle = () => setdeleteFilter(!deleteFilter);
    const [allLocation, setallLocation] = useState(false);
    const [allNewLocation, setallNewLocation] = useState(false);
    const [remove911Location, setRemove911Location] = useState(false);
    const toggleRemove911Location = () => setRemove911Location(!remove911Location);
    const [remove911LocationInfo, setRemove911LocationInfo] = useState();
    const [basicModal, setBasicModal] = useState(false);
    const toggleOpen = () => setBasicModal(!basicModal);
    const [removeLocation, setRemoveLocation] = useState(false);
    const toggleRemoveLocation = () => setRemoveLocation(!removeLocation);
    const [removeLocationInfo, setRemoveLocationInfo] = useState();
    const [successMessage, setSuccessMessage] = useState("");
    const addLocationRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [Add911Location, setAdd911Location] = useState(false);
    const toggleShow25 = () => setAdd911Location(!Add911Location);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [locationList, setlocationList] = useState([]);


    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,basicActive)
    function handleClick() {
        addLocationRef.current.click();
    }

    useEffect(() => {
        if (errorMessage) {
            setTimeout(() => {
                setErrorMessage(""); // Clear the error message in the parent component
            }, 5000);
        }
    }, [errorMessage]);

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    const allLocationData = {
        columns: [
            { label: "Name", field: "name", sort: true, colSpan: 2 },
            { label: "", field: "locTypes", sort: false, colSpan: 1 },
            { label: "Address", field: "Address", sort: true },
            { label: "911 Verified", field: "Verified", sort: false },
            { label: "Primary Contact", field: "contact", sort: true },
            { label: "Primary Number", field: "number", sort: true },
            { label: "Users", field: "user", sort: true },
            { label: "Devices", field: "Devices", sort: true },
            { label: "Remove", field: "Delete", sort: false },
        ],
        rows: filteredRows
    };

    // useEffect(() => {
    //     const patchTitles = () => {
    //         const tds = document.querySelectorAll('table td');
    //         tds.forEach(td => {
    //             if (!td.getAttribute('title')) {
    //                 td.setAttribute('title', td.textContent.trim());
    //             }
    //         });
    //     };

    //     // Patch immediately, then again slightly later
    //     patchTitles();
    //     const timer = setTimeout(patchTitles, 100);

    //     return () => clearTimeout(timer);
    // }, [allLocationData]);



    useEffect(() => {
        async function fetchAllLocationsInfo() {
            try {
                sessionStorage.setItem("current_link", "loclanding");
                console.log("[fetchAllLocationsInfo] ");
                let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
                setIsloading(true);
                let serverResponse = await getAllTheLocationsInfo(siteid, TabIDConstant.LOC_SUBLINK);
                setIsloading(false);

                if (!serverResponse.ok) {
                    console.log("Network response was not ok");
                    throw new Error('Network response was not ok');
                } else {
                    let responseData = await serverResponse.json()
                    console.log("fetchAllLocationsInfo List:::: " + JSON.stringify(responseData));
                    let apiData = responseData.all_locations;

                    let data = [];
                    setlocationList([...apiData].sort((a, b) =>
                        a.location_name.localeCompare(b.location_name)
                    ));
                    apiData.forEach(element => {
                        var json = {};
                        json.locDetails = element;
                        json.default_loc = element.default_loc;
                        json.actualName = element.location_name;
                        json.name = element.location_name;
                        json.locTypes =
                            <div>
                                {element.default_loc && (
                                    <>
                                        <div className="px-2 ms-2 border border-1 rounded-pill primary-locbtn text-center">
                                            <span className="small ">Primary</span>
                                        </div>
                                    </>
                                )}
                                {element.is_911 && (
                                    <>
                                        <div className="px-2 ms-2 border border-1 rounded-pill border-success text-center">
                                            <span className="small text-success">911 Only</span>
                                        </div>
                                    </>
                                )}
                            </div>;
                        json.Address = element.address;
                        json.Verified = element.noo_verified ? <MDBIcon fas icon="check" className="ms-4 ps-1 primary checked-icon" /> : <h6 class="no-red ms-4">No</h6>;
                        json.contact = element.pri_contact;
                        let phNumber = element.pri_num ? formattedNumber(element.pri_num) + "" : ""
                        json.phoneNum = element.pri_num + "" ?? ""
                        json.actualNumber = phNumber?.toString().replace(/[ ]/g, '');
                        json.number = phNumber;
                        json.user = element.is_911 ? '-' : (element.users ?? '-');
                        json.Devices = element.ip_phones_devices + "" ?? '-';
                        json.Delete = !element.default_loc ?
                            <>
                                <div className="d-flex align-items-center justify-content-center">
                                    <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(event) => {
                                        if (element.is_911) {
                                            handleDeleteUser911Location(event, element);
                                        } else {
                                            handleDeleteUserLocation(event, element);
                                        }
                                    }
                                    }
                                    >
                                        <i className="fas fa-xmark text-primary fs-5 mx-2 "></i>
                                    </div>
                                </div>
                            </>
                            : "";
                        json.location_id = element.location_id;
                        data.push(json);
                    });

                    console.log("final data is ::::::::::: " + JSON.stringify(data));
                    setallLocationsInfo(data);
                    setallLocationsInfoTemp(data);
                    // setFilteredRows(data)
                    setFilteredRows(data);
                    setDataLoaded(true)

                    const selectedlocation = sessionStorage.getItem("global_select_location") ?
                        JSON.parse(sessionStorage.getItem("global_select_location")) :
                        [];
                    const globalLoc = sessionStorage.getItem("global_location") ?
                        JSON.parse(sessionStorage.getItem("global_location")) :
                        [];
                    if (selectedlocation && !selectedlocation.includes(-1) && globalLoc && globalLoc.length > 0) {
                        const filterLocName = (globalLoc.filter((item) => selectedlocation.includes(item.value))).map((loc) => loc.text);

                        // console.log("In headr selection :::: " + JSON.stringify(filterLocName));

                        const updatedData = data.filter((item) => filterLocName.includes(item.name));
                        // console.log("In headr selection :::: " + JSON.stringify(updatedData));
                        setallLocationsInfo(updatedData);

                    }

                    // await getUserLocationFilter(data);
                }
            } catch (e) {
                console.log("[LocLanding.js][fetchAllLocationsInfo] : " + e);
            }

        }
        if (basicActive) {
            fetchAllLocationsInfo();
        }

    }, [basicActive]);

    function setDefaultValue(e) {
        e.preventDefault();
        if (LocationSelected) {
            setNewLocationSelectedIds([]);
        }
    }

    function handleSearch(e, flag) {
        const value = e.target.value;
        if (flag === 1) {
            setsearchMainValue(value);
            setdisplayFilterLocations(filterLocationList.filter((Location) => Location.entity_name.toLowerCase().includes(value.toLowerCase())));
        } else {
            setsearchEditValue(value);
            setdisplayNewFilterLocations(filterLocationList.filter((Location) => Location.entity_name.toLowerCase().includes(value.toLowerCase())));
        }
    }

    const handleDeleteUser911Location = (evntData, info) => {
        evntData.preventDefault();
        evntData.stopPropagation();
        console.log("IN handleDeleteUser911Location info Delete :" + JSON.stringify(info));
        toggleRemove911Location();
        setRemove911LocationInfo({ ...info, nineoo_loc_id: info.location_id });
    }

    const handleDeleteUserLocation = (evntData, info) => {
        evntData.preventDefault();
        evntData.stopPropagation();
        console.log("IN handleDeleteUserLocation info Delete :" + JSON.stringify(info));
        toggleRemoveLocation();
        setRemoveLocationInfo(info);
    }


    function showThisCombinationInf(evntData) {
        console.log("911 evntData ::::::::: " + JSON.stringify(evntData));
        const currentIndex = locationList.findIndex((tmdata) => tmdata.location_id == evntData.locDetails.location_id);
        const previousLoc = currentIndex > 0 ? locationList[currentIndex - 1] : null;
        const nextLoc = currentIndex < locationList.length - 1 ? locationList[currentIndex + 1] : null;
        const currentLoc = evntData.locDetails;
        const combinedData = {
            currentLoc,
            previousLoc,
            nextLoc,
            locationList
        };
        if (evntData.locDetails.is_911) {
            navigate("/location911settings", {
                state: combinedData,
            });
        } else {
            navigate("/locDetails", {
                state: combinedData,
            });
        }
        // if (evntData.locDetails.is_911) {
        //     navigate("/location911settings", {
        //         state: evntData.locDetails,
        //     });
        // } else {
        //     navigate("/locDetails", {
        //         state: evntData.locDetails,
        //     });
        // }
    }

    useEffect(() => {
        if (filterReRender) {
            getUserLocationFilter();
            setFilterReRender(false);
        }
    }, [filterReRender]);


    async function getUserLocationFilter(data) {
        try {
            const adminSession = sessionStorage.getItem("admin_session");
            const siteid = JSON.parse(adminSession).siteid;
            let response;
            const extracondition = `?module_type=3`;
            response = await getGlobalLocationList(siteid, extracondition);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            let rawData = await response.json();
            console.log(" Global user Location filter ::::::::: : " + JSON.stringify(rawData));
            if (!rawData) {
                window.alert(`info with id  not found`);
                // navigate("/");
            }
            const userLocationsFilter = rawData?.result ?? [];
            setTheStateValues(userLocationsFilter, data);
            // sessionStorage.setItem("userLocationFilter", JSON.stringify(userLocationsFilter));

        } catch (error) {

        }

    }

    function setTheStateValues(userLocationsFilter, data) {
        let LocationSelected = userLocationsFilter.filter(userLocation => userLocation.selected).map(userLocation => userLocation.entity_name).join(', ');
        const LocationSelectedids = userLocationsFilter.some(location => location.entity_id === -1 && location.selected)
            ? userLocationsFilter.map(location => location.entity_id)
            : userLocationsFilter.filter(location => location.selected).map(location => location.entity_id);
        const index = LocationSelectedids.findIndex(id => id === -1);
        if (index !== -1) {
            LocationSelectedids.splice(index, 1);
            LocationSelected = "";
            setNewLocationSelectedIds(LocationSelectedids);
            setexistNewLocationSelectIds(LocationSelectedids);
            // setallLocation(true);
            setallNewLocation(true);
        }

        const newuserLocationsFilter = userLocationsFilter.filter((loc) => parseInt(loc.entity_id) !== -1);
        setfilterLocationList(newuserLocationsFilter);
        setdisplayFilterLocations(newuserLocationsFilter);
        setdisplayNewFilterLocations(newuserLocationsFilter);
        if (LocationSelected && LocationSelected !== "") {
            // debugger;
            setLocationSelected(`${t("Locations")} : ${LocationSelected}`);
            setLocationSelectedIds(LocationSelectedids);
            setexistLocationSelectIds(LocationSelectedids);
            if (data && data.length > 0) {
                const updatedLocation = data.filter((loc) => LocationSelectedids.includes(loc.location_id));
                setallLocationsInfo(updatedLocation);
            }

        }

    }
    function cancelfilterChanges(flag) {
        if (flag === 1) {
            setLocationSelectedIds(existLocationSelectIds);
            if (existLocationSelectIds.length === filterLocationList.length || existLocationSelectIds.length === displayFilterLocations.length) {
                setallLocation(true);
            } else {
                setallLocation(false);
            }
        } else {
            setNewLocationSelectedIds(existNewLocationSelectIds);
            if (existNewLocationSelectIds.length === filterLocationList.length || existNewLocationSelectIds.length === displayFilterLocations.length) {
                setallNewLocation(true);
            } else {
                setallNewLocation(false);
            }
        }
    }

    const handleFilterCheckboxChange = (value) => {
        const updatedValues = [...LocationSelectedIds];
        if (updatedValues.includes(value)) {
            // If already selected, remove it
            updatedValues.splice(updatedValues.indexOf(value), 1);
        } else {
            // If not selected, add it
            updatedValues.push(value);
        }
        if (updatedValues.length !== displayFilterLocations.length) {
            setallLocation(false);
        } else {
            const tempArray = displayFilterLocations.map(loc => loc.entity_id);
            const sortedArr1 = [...tempArray].sort();
            const sortedArr2 = [...updatedValues].sort();

            // Compare each element
            for (let i = 0; i < sortedArr1.length; i++) {
                if (sortedArr1[i] !== sortedArr2[i]) {
                    setallLocation(false);
                    break;
                }
            }
            setallLocation(true);
        }
        setLocationSelectedIds(updatedValues);
    };

    const handleNewFilterCheckboxChange = (value) => {
        const updatedValues = [...newLocationSelectedIds];
        if (updatedValues.includes(value)) {
            // If already selected, remove it
            updatedValues.splice(updatedValues.indexOf(value), 1);
        } else {
            // If not selected, add it
            updatedValues.push(value);
        }

        if (updatedValues.length !== displayNewFilterLocations.length) {
            setallNewLocation(false);
        } else {
            const tempArray = displayNewFilterLocations.map(loc => loc.entity_id);
            const sortedArr1 = [...tempArray].sort();
            const sortedArr2 = [...updatedValues].sort();

            // Compare each element
            for (let i = 0; i < sortedArr1.length; i++) {
                if (sortedArr1[i] !== sortedArr2[i]) {
                    setallNewLocation(false);
                    break;
                }
            }
            setallNewLocation(true);
        }

        setNewLocationSelectedIds(updatedValues);
    };

    function isArraysEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }

        // Sort both arrays
        const sortedArr1 = [...arr1].sort();
        const sortedArr2 = [...arr2].sort();

        // Compare each element
        for (let i = 0; i < sortedArr1.length; i++) {
            if (sortedArr1[i] !== sortedArr2[i]) {
                return false;
            }
        }

        return true;

    }


    const ApplyFilter = async (event, selectValue) => {
        event.preventDefault();
        let filteredValue = [...selectValue];
        console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
        const adminSession = sessionStorage.getItem("admin_session");
        const siteid = JSON.parse(adminSession).siteid;
        if (selectValue.length === filterLocationList.length) {
            filteredValue = [-1];

        }
        let update = {
            reqid: 62,
            siteid: siteid,
            filter_value: filteredValue,
            filter_type: 1,
            filter_key: 3,
            module_type: 3,
        }
        // if (loggedinUser.indexOf("@") !== -1) {
        //   update.agentid = loggedinUser;
        // }
        console.log("Modify Location user filter value  :::: " + JSON.stringify(update));
        setIsloading(true);
        let saverep = await setGlobalLocationFilter(update);
        setIsloading(false);
        console.log(`reponse of Edit Location user :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(
            "response of modified Location user data :::" + JSON.stringify(saverepeMsg)
        );
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            setSuccessMessage(saverepeMsg.message);
            // sessionStorage.removeItem('userLocationFilter');
            // window.location.href = "/LocLanding";

            const updatedLocation = allLocationsInfoTemp.filter((loc) => selectValue.includes(loc.location_id));
            setallLocationsInfo(updatedLocation);
            setFilterReRender(true);



        }
        else {

            localStorage.setItem("f_message", saverepeMsg.message);
        }
    }

    function removeAllLocs() {
        removeAllLocFilter(3);

    }

    const removeallfiltersLoc = (value) => {
        removeAllLocFilter(-1);

    }

    async function removeAllLocFilter(filterKey) {
        // e.preventDefault();
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        setIsloading(true);
        let update = {
            reqid: 62,
            siteid: siteid,
            filter_value: [-1],
            filter_type: 1,
            filter_key: filterKey ? parseInt(filterKey) : -1,
            module_type: 3,
        }

        console.log("Modify User filter value  :::: " + JSON.stringify(update));
        let deleteFilter = await setGlobalLocationFilter(update);
        setIsloading(false);

        let deleteMsg = await deleteFilter.json();
        console.log("Response... ");
        console.log("response to remove the filter :::::::::::::; " + JSON.stringify(deleteMsg));
        if (deleteMsg.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            window.location.href = "/LocLanding";

        } else {
            setSuccessMessage(deleteMsg.message);
            // sessionStorage.removeItem('userLocationFilter');
            // window.location.href = "/LocLanding";
            // const updatedLocation = allLocationsInfoTemp.filter((loc) => selectValue.includes(loc.location_id));
            // setallNewLocation(true);
            setallLocationsInfo(allLocationsInfoTemp);
            setLocationSelected("");
            setFilterReRender(true);

        }
    }

    function handleAllLocation(e) {
        // e.preventDefault();
        setallLocation(e.target.checked);
        if (e.target.checked) {
            const locId = displayFilterLocations.map(loc => loc.entity_id);
            setLocationSelectedIds(locId);
        } else {
            setLocationSelectedIds([]);
        }

    }
    function handleNewAllLocation(e) {
        // e.preventDefault();
        setallNewLocation(e.target.checked);
        if (e.target.checked) {
            const locId = displayNewFilterLocations.map(loc => loc.entity_id);
            setNewLocationSelectedIds(locId);
        } else {
            setNewLocationSelectedIds([]);
        }

    }


    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);

        const filteredUsers = customSearch(allLocationsInfo, searchValue, UIConstant.LOCATION_LANDING);

        setFilteredRows(filteredUsers);
    };



    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('table td');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };

        patchTitles();

        const table = document.querySelector('.locationDatatable');

        if (!table) return;

        const observer = new MutationObserver(() => {
            patchTitles();
        });

        observer.observe(table, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);





    return (
        <>
            <div>

                <div className="d-flex align-items-center justify-content-between actionbar  ">
                    <div>

                        <MDBBtn
                            className="green-button d-inline-block float-end"
                            data-mdb-toggle="modal"
                            data-mdb-target="#exampleModal"
                            onClick={toggleOpen}
                        >
                            <MDBIcon fas icon="plus" size="sm" /> {t("addlocation")}

                        </MDBBtn>
                    </div>

                    <div>

                        <MDBBtn
                            className="green-button d-inline-block float-end ms-3"
                            data-mdb-toggle="modal"
                            data-mdb-target="#exampleModal"
                            onClick={toggleShow25}
                        >
                            <MDBIcon fas icon="plus" size="sm" /> {t("Add911Loc")}
                        </MDBBtn>
                    </div>
                </div>
                {/* <div className="position-absolute left__341px d-flex">
                    <div className="d-flex">
                        <div className="ms-4 popconfirmFilter">
                            {LocationSelected && (
                                <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                                    <MDBChip closeIcon className="m-0" onClick={(e) => setDefaultValue(e)}
                                        onDelete={removeAllLocs}
                                    >
                                        <div className="filterElliipse">
                                            {LocationSelected}
                                        </div>
                                    </MDBChip>
                                </>}>
                                    <MDBPopconfirmMessage className="p-2">
                                        <p className='mb-2 fw-600'>
                                            {t("location")}
                                        </p>
                                        <div className="d-flex align-items-center">
                                            <div className="ms-2 w-100">
                                                <MDBInput placeholder="search" value={searchMainValue} onChange={(e) => handleSearch(e, 1)} />
                                            </div>
                                        </div>
                                        <div className="filter-border py-2"></div>
                                        <div className="mt-3 w-100">
                                            <MDBCheckbox checked={allLocation} onChange={(e) => handleAllLocation(e)} label='Select All' />
                                        </div>
                                        <div className="filtersScroll">
                                            {displayFilterLocations && displayFilterLocations.map((Location) => (
                                                <MDBCheckbox name='flexCheck' value={Location.entity_id} id={Location.entity_id} label={Location.entity_name} checked={LocationSelectedIds.includes(Location.entity_id)}
                                                    onChange={() => handleFilterCheckboxChange(Location.entity_id)}
                                                />
                                            ))}
                                        </div>
                                        <div className="filter-border"></div>
                                        <div className="d-flex float-end mt-3">
                                            {(LocationSelectedIds.length > 0 && !isArraysEqual(LocationSelectedIds, existLocationSelectIds)) && (
                                                <>
                                                    <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(1)}>Cancel</MDBBtn>
                                                    <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                                                        ApplyFilter(e, LocationSelectedIds);
                                                    }}> Apply</MDBBtn>
                                                </>
                                            )}
                                        </div>
                                    </MDBPopconfirmMessage>
                                </MDBPopconfirm>
                            )}
                        </div>
                    </div>
                    {!LocationSelected && (
                        <div className=" ms-2">


                            <MDBPopconfirm placement='bottom-start' onClick={(e) => setDefaultValue(e)} className="shadow-6" btnChildren={(<>  <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}</>)}>
                                <MDBPopconfirmMessage className="p-2">
                                    <p className='mb-2 fw-600'>
                                        {t("location")}
                                    </p>

                                    <div className="d-flex align-items-center">
                                        <div className="ms-2 w-100 position-relative">
                                            <MDBInput placeholder="search" value={searchEditValue} onChange={(e) => handleSearch(e, 2)} />
                                        </div>
                                    </div>
                                    <div className="filter-border py-2"></div>

                                    <div className="mt-3 searchCheckbox-align">
                                        <MDBCheckbox checked={allNewLocation} onChange={(e) => handleNewAllLocation(e)} label='Select All' />
                                    </div>
                                    <div className="filtersScroll">
                                        {displayNewFilterLocations && displayNewFilterLocations.map((Location) => (
                                            <div className="mt-2">
                                                <MDBCheckbox name='flexCheck' value={Location.entity_id} id={Location.entity_id} label={Location.entity_name} checked={newLocationSelectedIds.includes(Location.entity_id)}
                                                    onChange={() => handleNewFilterCheckboxChange(Location.entity_id)}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    <div className="filter-border"></div>
                                    <div className="d-flex float-end mt-3">
                                        {(newLocationSelectedIds.length !== 0 && newLocationSelectedIds.length !== filterLocationList.length) && (
                                            <>
                                                <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(2)}>Cancel</MDBBtn>
                                                <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                                                    ApplyFilter(e, newLocationSelectedIds);
                                                }}> Apply</MDBBtn>
                                            </>
                                        )}

                                    </div>
                                </MDBPopconfirmMessage>
                            </MDBPopconfirm>

                        </div>
                    )}

                    {LocationSelected && (
                        <MDBBtn className="mx-2" onClick={removeallfiltersLoc}>Clear</MDBBtn>
                    )}

                </div> */}
                <div className='mb-2 mt-4 position-relative w-auto'>
                    <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <div className="locDataTable actioncolumn">
                    <MDBDatatable
                        key={searchValue}
                        className='locationDatatable'
                        // search
                        sortField="Name"
                        // data={allLocationData}
                        data={{
                            ...allLocationData,
                            rows: filteredRows, // Use filtered rows here
                        }}
                        fixedHeader
                        noFoundMessage="No results"
                        entries={50}
                        onRowClick={(event) => {
                            showThisCombinationInf(event);
                        }} />
                </div>

            </div>
            {remove911Location && (
                <PopupLoaderNew
                    title={"Remove 911 Only Location"}
                    content={
                        <Remove911Locations
                            onClose={toggleRemove911Location}
                            remove911LocationInfo={remove911LocationInfo}
                            ref={addLocationRef}
                            isloading={isLoading}
                            setIsloading={setisLoading}
                        />
                    }
                    className={""}
                    onShow={setRemove911Location}
                    onClose={toggleRemove911Location}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )
            }
            {removeLocation && (
                <PopupLoader
                    title={"Remove Location"}
                    content={
                        <RemoveLocations
                            onClose={toggleRemoveLocation}
                            removeLocationInfo={removeLocationInfo}
                        />
                    }
                    className={""}
                    onShow={setRemoveLocation}
                    onClose={toggleRemoveLocation}
                />
            )
            }
            {deleteFilter && (
                <PopupLoader
                    title={"Delete Location Filter"}
                    content={<DeleteLocationFilter
                        locationflag={2}
                        onClose={deleteFilterToggle}
                    />}
                    onShow={setdeleteFilter}
                    onClose={deleteFilterToggle}
                />
            )}
            {successMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{successMessage}</span>
                </MDBAlert>
            )}
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}

            {errorMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-times-circle me-3"></i>
                    <span className="alert-msg">{errorMessage}</span>
                </MDBAlert>
            )}

            {basicModal && (
                <PopupLoaderNew
                    title={"Add Location"}
                    content={<AddLocations
                        onClose={toggleOpen}
                        ref={addLocationRef}
                        setIsloading={setisLoading}
                        allLocation={true}
                    />}
                    className="modal-lg"
                    onShow={setBasicModal}
                    onClose={toggleOpen}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                />
            )}

            {Add911Location && (
                <PopupLoaderNew
                    title={t("Add911Loc")}
                    content={<AddNineOneOneLocation
                        setSuccessMessage={setSuccessMessage}
                        removeFlag={false}
                        setErrorMessage={setErrorMessage}
                        onClose={toggleShow25}
                        ref={addLocationRef}
                        setIsloading={setisLoading}
                        allLocation={true}

                    />}
                    onShow={setAdd911Location}
                    onClose={toggleShow25}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                />
            )}
        </>
    )
}

export default AllLocations
